import { createUserManager } from 'redux-oidc';
const path = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${global.applicationPath}`;

const userManagerConfig = {
    client_id: global.IdpClientId,
    redirect_uri: `${path}/signin-oidc`,
    post_logout_redirect_uri: `${path}/signout-oidc`,
    response_type: 'id_token token',
    scope: 'openid profile SOC.Service.WebApi roles groups',
    authority: global.IdpUrl,
    silent_redirect_uri: `${path}/dist/silent_renew.html`,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true
};

const userManager = createUserManager(userManagerConfig);

export default userManager;


// WEBPACK FOOTER //
// ./src/oidc/userManager.js